import { CommitResponse, EmailVerificationResult, JoinResponse, Verified } from 'src/data/types/onboarding/types';
import { CioData } from 'src/types';
import { createController, createControllerEndpoint } from 'src/utils/api';

export default createController('/onboarding', {
    checkIsVerified: createControllerEndpoint<Verified>('GET', '/check-verified'),
    getCioData: createControllerEndpoint<CioData>('GET', '/get-cio-data'),
    getMfaQrCode: createControllerEndpoint<any>('GET', '/get-mfa-qr'),
    verifyEmails: createControllerEndpoint<EmailVerificationResult>('POST', '/check-emails-validity'),
    resendVerificationEmail: createControllerEndpoint<void>('POST', '/resend-verification-email'),
    commitUserSetup: createControllerEndpoint<CommitResponse>('POST', '/commit-user-setup'),
    commitMfa: createControllerEndpoint<{
        confirmed:boolean
        type:string
    }>('POST', '/commit-mfa'),
    commitCompanySetup: createControllerEndpoint<CommitResponse>('POST', '/commit-company-setup'),
    joinCompany: createControllerEndpoint<JoinResponse>('POST', '/join'),
});